import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-FDJVSWXE2Z';

const GoogleAnalytics = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  // Track page views on route change (including initial load)
  // index.html uses send_page_view: false to avoid duplicate initial hit
  useEffect(() => {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
      send_to: GA_MEASUREMENT_ID,
    });

    isFirstRender.current = false;
  }, [location]);

  return null;
};

export default GoogleAnalytics;
